// Module to hold functions to assist working with store location
import config from 'shared/config';
import React from 'react';

/**
 *  Get the Nop Warehouse Id for the initial store from storage
 */
const getInitialStore = () => {
	let initialStore;
	if (config.SET_ITEM_ENABLED) {
		initialStore = localStorage.getItem('initialStore');
		return initialStore != null ? parseInt(initialStore, 10) : 0;
	}
	initialStore = config.INITIAL_STORE;
	return initialStore != null ? initialStore : 0;
};

/**
 * Get the Nop Warehouse id for the store location from storage
 */
const getStoreLocation = () => {
	let storeLocation;
	if (config.SET_ITEM_ENABLED) {
		storeLocation = localStorage.getItem('storeLocation');
		return storeLocation !== null ? parseInt(storeLocation, 10) : 0;
	}
	storeLocation = config.STORE_LOCATION;
	return storeLocation != null ? storeLocation : 0;
};

/**
 * Get list of stores
 */
const getStores = () => {
	if (config.SET_ITEM_ENABLED) {
		return JSON.parse(localStorage.getItem('stores'));
	}
	return JSON.parse(config.STORES);
};

const getStoreName = storeId => {
	const stores = getStores();
	const store = stores.find(currentStore => currentStore.Id === storeId);
	return store.Name;
};

/**
 * Set the initial store location in storage
 * @param {string} nopWarehouseId
 */
const setInitialStore = (nopWarehouseId = 0) => {
	if (config.SET_ITEM_ENABLED) {
		localStorage.setItem('initialStore', nopWarehouseId);
	} else {
		config.INITIAL_STORE = nopWarehouseId;
	}
};

/**
 * Set the store location in local storage
 * @param {string} nopWarehouseId the Nop Warehouse Id
 */
const setStoreLocation = (nopWarehouseId = 0) => {
	if (config.SET_ITEM_ENABLED) {
		localStorage.setItem('storeLocation', nopWarehouseId);
	} else {
		config.STORE_LOCATION = nopWarehouseId;
	}
};

/**
 * Set stores in local storage using the config STORES setting.
 */
const setStores = () => {
	if (config.SET_ITEM_ENABLED) {
		localStorage.setItem('stores', config.STORES);
	}
};

export {
	getInitialStore,
	getStoreLocation,
	getStoreName,
	getStores,
	setInitialStore,
	setStoreLocation,
	setStores,
};
